import { useMemo } from 'react';
import { useFormikContext } from 'formik';
import {
  Avatar,
  Card,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
} from '@mui/material';
import {
  Book,
  Layers3,
  PaintRoller,
  PenTool,
  Ruler,
  SquareUserRound,
  StickyNote,
} from 'lucide-react';
import { green } from '@mui/material/colors';
import {
  products,
  finishing,
  dimentions,
  materials,
  printing,
} from './constants';

const Sidebar = () => {
  const { values } = useFormikContext<{
    product: string;
    finishing: string;
    material: string;
    dimention: string;
    printing: string;
    design: string;
    contact: {
      name: string;
      lastname: string;
      email: string;
      phone: string;
      message: string;
    };
  }>();

  const selectedProduct = useMemo(
    () => products[values?.product],
    [values?.product]
  );
  const selectedFinish = useMemo(
    () => finishing[values?.finishing],
    [values?.finishing]
  );
  const selectedMaterial = useMemo(
    () => materials[values?.material],
    [values?.material]
  );
  const selectedDimention = useMemo(
    () => dimentions[values?.dimention],
    [values?.dimention]
  );
  const selectedPrinting = useMemo(
    () => printing[values?.printing],
    [values?.printing]
  );

  const test = useMemo(() => {
    switch (values.design) {
      case 'yes':
        return 'Sí, tengo diseño';
      case 'changes':
        return 'Tengo Diseño, pero necesito cambios';
      case 'no':
        return 'No tengo diseño, necesitaría sus servicios';
    }
  }, [values.design]);

  return (
    <Card>
      <List sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}>
        <ListItem>
          <ListItemAvatar>
            <Avatar sx={{ bgcolor: selectedProduct ? green[500] : undefined }}>
              <Book />
            </Avatar>
          </ListItemAvatar>
          <ListItemText
            primary="Producto"
            secondary={selectedProduct?.label ? selectedProduct?.label : 'N/A'}
          />
        </ListItem>
        <ListItem>
          <ListItemAvatar>
            <Avatar sx={{ bgcolor: selectedFinish ? green[500] : undefined }}>
              <PaintRoller />
            </Avatar>
          </ListItemAvatar>
          <ListItemText
            primary="Acabado"
            secondary={selectedFinish?.label ? selectedFinish?.label : 'N/A'}
          />
        </ListItem>
        <ListItem>
          <ListItemAvatar>
            <Avatar sx={{ bgcolor: selectedMaterial ? green[500] : undefined }}>
              <Layers3 />
            </Avatar>
          </ListItemAvatar>
          <ListItemText
            primary="Material"
            secondary={
              selectedMaterial?.label ? selectedMaterial?.label : 'N/A'
            }
          />
        </ListItem>
        <ListItem>
          <ListItemAvatar>
            <Avatar
              sx={{ bgcolor: selectedDimention ? green[500] : undefined }}
            >
              <Ruler />
            </Avatar>
          </ListItemAvatar>
          <ListItemText
            primary="Dimensión"
            secondary={
              selectedDimention?.label ? selectedDimention?.label : 'N/A'
            }
          />
        </ListItem>
        <ListItem>
          <ListItemAvatar>
            <Avatar sx={{ bgcolor: selectedPrinting ? green[500] : undefined }}>
              <StickyNote />
            </Avatar>
          </ListItemAvatar>
          <ListItemText
            primary="Impresión"
            secondary={
              selectedPrinting?.label ? selectedPrinting?.label : 'N/A'
            }
          />
        </ListItem>
        <ListItem>
          <ListItemAvatar>
            <Avatar sx={{ bgcolor: values.design ? green[500] : undefined }}>
              <PenTool />
            </Avatar>
          </ListItemAvatar>
          <ListItemText primary="Diseño" secondary={test ? test : 'N/A'} />
        </ListItem>
        <ListItem>
          <ListItemAvatar>
            <Avatar sx={{ bgcolor: values.contact ? green[500] : undefined }}>
              <SquareUserRound />
            </Avatar>
          </ListItemAvatar>
          <ListItemText
            primary="Contacto"
            secondary={values.contact ? 'Contacto listo' : 'N/A'}
          />
        </ListItem>
      </List>
    </Card>
  );
};

export default Sidebar;
